<template lang="pug">
#app
  Items
  Modal
  Loading
  Contact
  Form
</template>

<script>
import { mapActions, mapMutations } from "vuex";
import Items from "../components/items.vue";
import Modal from "../components/modal.vue";
import Loading from "../components/loading.vue";
import Contact from "../components/contact.vue";
import Form from "../components/form.vue";

export default {
  components: {
    Items,
    Modal,
    Loading,
    Contact,
    Form,
  },
  created() {
    this.unsetIndices();
    this.toggleLoading();
    this.toggleScroll();
    window.setTimeout(() => {
      this.fetchIndices({ page: this.page, query: this.query });
      this.toggleLoading();
    }, 1000);
  },
  methods: {
    ...mapMutations([
      "unsetIndices",
      "updateTaxonomies",
      "toggleScroll",
      "toggleLoading",
    ]),
    ...mapActions(["fetchIndices", "fetchTaxonomies"]),
  },
};
</script>

<style lang="scss" scoped>
body {
  font-size: 24px;
}
</style>
